export default "__VITE_ASSET__Dw2pIU8b__"